import React, { useState, useEffect } from 'react';
import Main from '../componentes/Main';
import Axios from 'axios';
import { Grid } from "@material-ui/core";
import { Spinner, Card, Typography, Input, IconButton, Tooltip, Dialog, DialogHeader, DialogBody, DialogFooter, Button, Select, Option } from '@material-tailwind/react';
import { MagnifyingGlassIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import Swal from 'sweetalert2';
import ExportToExcelLibroFET from '../componentes/exportToExcelLibroFET';
import { useContextoGlobal } from '../Context/contextoGlobal';
import { ListadoCelular } from '../componentes/ListadoCelular'
import { Fecha } from '../componentes/Fecha'
import { esMayor, obtenerFechaDiamenosN } from '../Helpers/fechas'

const ICajaModel = {
    nombre: '',
    id_rubro_ingreso: '',
    id_rubro_egreso: '',
    saldo: ''
}

export default function LibrosFET() {

    const [cajasRubroList, setCajasRubroList] = useState([])
    const [buscandoDatos, setBuscandoDatos] = useState(false)
    const [open, setOpen] = React.useState(false); 
    const { esCelular } = useContextoGlobal();
    const [listaFET,setListaFET] = useState([]);
    const [dataValues, setDataValues] = useState({
        id_caja_rubro: null,
        fecha_desde: obtenerFechaDiamenosN(365).date,
        fecha_hasta: new Date(),
    });

    const handleDataChanges = (value, type) => {
        setDataValues({ ...dataValues, [type]: value });
    }

    useEffect(() => {
        obtenerArchivos()
    }, [])

    const obtenerArchivos = async () => {
        setBuscandoDatos(true);
        try {
            const resultList = await Promise.all([Axios.get(`/api/tablasgenerales/cajasrubros`)])
            setCajasRubroList(resultList[0].data)
            setBuscandoDatos(false);
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }
  
        const buscarDatos = async (params = {}) => {
            //setHuboError(false)
            setListaFET([])
            setBuscandoDatos(true)
            try {
                const params ={
                    ...dataValues,
                }
                const { data } = await Axios.post(`/api/tablasgenerales/librocaja/fet`,params)
                console.log("librocaja fet", data);
                setListaFET(data)
                setBuscandoDatos(false)
            } catch (err) {
                console.log(err)
                // setHuboError(true)
                 setBuscandoDatos(false)
            }
    }

    const limpiarBusqueda = async () => {
        setDataValues({...dataValues,id_caja_rubro:null});
        setListaFET([])
    }

    if (buscandoDatos) {
        return <Main center alinear>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando archivos...</span>
            </div>
        </Main>
    }

    if (cajasRubroList.length == 0) {
        return <Grid container justifyContent='center' alignItems='center' style={{ minHeight: '400px', textAlign: 'center' }} >
            <Grid item>
                <Typography variant="h5">
                    No se encontraron archivos
                </Typography>
            </Grid>
        </Grid>
    }

    return <div className='w-full flex flex-col justify-center items-center lg:!m-6 xl:!m-6'>
        <Typography variant="h4" className="flex ">
            Libro FET
        </Typography>
        <Card className='w-full justify-center items-center flex p-5 justify-left mt-4'>
            <Cabecera 
                fet={cajasRubroList}
                handleDataChanges={handleDataChanges}
                dataValues={dataValues}
                buscarDatos={buscarDatos}
            />
            {listaFET.length > 0 && <div className='mt-8 w-full'>
                <div className="flex flex-col md:flex-row gap-2 xl:!justify-end">
                    <Button variant='text' className='text-red-400 bg-red-100 hover:bg-red-200' onClick={limpiarBusqueda}>Limpiar Busqueda</Button>
                    <ExportToExcelLibroFET data={listaFET} fileName="Listado de libros FET"/>
                </div>
                <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-normal leading-none hidden lg:flex"
                >
                    Se han encontrado {listaFET.length} FETs
                </Typography>
                {esCelular ? 
                    <ListadoCelular datos={listaFET}/>
                        :
                    <table className="w-full min-w-max table-auto text-left mt-2">
                        <thead>
                            <tr>
                                 <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Fecha
                                    </Typography>
                                </th>
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Aportante/Proveedor
                                    </Typography>
                                </th>                                
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Descripción
                                    </Typography>
                                </th>
                                {/* <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Saldo acumulado
                                    </Typography>
                                </th> */}
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Debe
                                    </Typography>
                                </th>
                                <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Haber
                                    </Typography>
                                </th>
                                 <th
                                    className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                >
                                    <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal leading-none opacity-70"
                                    >
                                        Saldo Total
                                    </Typography>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {listaFET.map((item, index) => {
                                const isLast = index === listaFET.length - 1;
                                const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                                return (
                                    <tr key={index}>
                                        <td className={classes}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {item.fecha}
                                            </Typography>
                                        </td>
                                         <td className={classes}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {item.aportante_proveedor}
                                            </Typography>
                                        </td>
                                        <td className={classes}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {item.descripcion}
                                            </Typography>
                                        </td>
                                         {/* <td className={`${classes} text-right`}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {not_null(item.saldo_acum).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </Typography>
                                        </td>                                         */}
                                        <td className={`${classes} text-right`}>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-normal"
                                            >
                                                {not_null(item.debe).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </Typography>
                                        </td>
                                         <td className={`${classes} text-right`}>
                                            <Typography
                                                variant="small"
                                                color={not_null(item.haber) > 0 ? "red" : "blue-gray"}
                                                className="font-normal"
                                            >
                                                {not_null(item.haber).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </Typography>
                                        </td>
                                        <td className={`${classes} text-right`}>
                                            <Typography
                                                variant="small" 
                                                color={not_null(item.saldo_total) < 0 ? "red" : "blue-gray"}
                                                className="font-normal"
                                            >
                                                {not_null(item.saldo_total).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </Typography>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table> 
                }


            </div>}
        </Card>
    </div>
}

const not_null = (value)=>{
    return !!value ? value : 0;
}

const Cabecera = ({buscarDatos,
    fet,
    handleDataChanges,
    dataValues,
}) => {

    const { esCelular } = useContextoGlobal();

    const handleCuentaChange = (e) => {
        handleDataChanges(e, 'id_caja_rubro')
    }

    const handleSearchData = () => {
        if (esMayor(dataValues.fecha_desde, dataValues.fecha_hasta)) {
            alert('El orden de las fechas es incorrecto');
            return
        } 
        
        if(!dataValues?.id_caja_rubro){
            alert('Seleccione un FET');
            return
        }

        buscarDatos();
        
    };


    return <div className='flex f-col mt-4'>
        <div className={`flex ${esCelular ? 'f-col space-y-2' : 'f-row space-x-4'} justify-center flex-wrap abc`}>
            
            <SeleccionadorXLabel titulo='FET'
                vector={fet.map(item => ({ id_region: item.id_caja_rubro, nombre: item.nombre }))}
                onchange={handleCuentaChange}
                claves={{ id: 'id_caja_rubro', nombre: 'nombre' }}
                valor={dataValues.id_caja_rubro}
                nombre='Seleccione un FET'
            />
            <div>
                <Typography
                    variant="small"
                    className="mb-1 font-medium "
                >
                    Fecha Desde
                </Typography>
                <Fecha fecha={dataValues.fecha_desde} setFecha={(e) => handleDataChanges(e, 'fecha_desde')} />
            </div>
            <div>
                <Typography
                    variant="small"
                    className="mb-1 font-medium "
                >
                    Fecha Hasta
                </Typography>
                <Fecha fecha={dataValues.fecha_hasta} setFecha={(e) => handleDataChanges(e, 'fecha_hasta')} />
            </div>
            
        </div>
          <div class="flex justify-center lg:justify-end ... lg:mr-4">
                <Button
                    size="lg"
                    color="blue"
                    className="rounded flex mt-[28px]"
                    onClick={handleSearchData}
                >
                    <MagnifyingGlassIcon className="h-4 w-4 mr-2" />Ejecutar
                </Button>
            </div>
    </div>
}

const SeleccionadorXLabel = ({ vector, onchange, valor, nombre, limpiar, claves, titulo, noDefault }) => {

    return <div className='select-ui-data !mb-4'>
        <Typography
            variant="small"
            className="mb-1 font-medium "
        >
            {titulo}
        </Typography>
        <Select
            label="Seleccione una opción"
            value={valor}
            onChange={onchange}
            className='h-14'
        >
            {vector.map((item, index) => (
                <Option key={index} value={item.id_region}>
                    {item.nombre}
                </Option>
            ))}
        </Select>
    </div>
}